function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "\\uADF8\\uB8F9_1466"
}, /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_759",
  d: "M6.211 21.727V10.818h13.263v1.091a7.729 7.729 0 0 1 2.211.316v-1.407a2.2 2.2 0 0 0-2.211-2.182h-1.106V6.455a5.527 5.527 0 0 0-11.053 0v2.181H6.211A2.2 2.2 0 0 0 4 10.818v10.909a2.2 2.2 0 0 0 2.211 2.182h6.919a7.739 7.739 0 0 1-1.072-2.182zM9.526 6.455a3.316 3.316 0 0 1 6.632 0v2.181H9.526z",
  className: "cls-1",
  transform: "translate(-4 -1)"
}), /*#__PURE__*/React.createElement("path", {
  id: "\\uD328\\uC2A4_760",
  d: "M18.526 13a5.455 5.455 0 1 0 5.526 5.455A5.493 5.493 0 0 0 18.526 13zm1.824 8.018l-2.376-2.345v-3.491h1.105v3.044l2.045 2.018z",
  className: "cls-1",
  transform: "translate(-3.053 .091)"
}));

function SvgIconLocktime(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "icon_locktime",
    width: 21,
    height: 24,
    viewBox: "0 0 21 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocktime);
export default __webpack_public_path__ + "static/media/icon-locktime.dcb0802d.svg";
export { ForwardRef as ReactComponent };